import React from 'react';

import { Card } from 'react-bootstrap';
import { Chart, CommonSeriesSettings, Series, Export, ArgumentAxis, Margin, Legend, Tooltip, Grid, Label } from 'devextreme-react/chart';

import { getCategoryFromOrigin } from "../helpers/requestHandler";
import { exportData, renderFullScreen } from '../helpers/utils';

const axisTitles = [
    { value: 'count', name: 'Communicated Notices' },
];

export const updateUsersInstance = () => {
    window.lineChartMonthlyNotices.loadData();
}

export const updateUsersRange = () => {
  window.lineChartMonthlyNotices.loadData();
}

class lineChartMonthlyNotices extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            getData: ''
        };
        window.lineChartMonthlyNotices = this;
    }

    async componentDidMount() {
        await this.loadData();
    }

    loadData = async () => { //Adjust in regard to start date and end date
        this.setState({ getData: [] });
        let resp = await getCategoryFromOrigin(global.config.backend.baseURI + "/api/Statistic/GetMonthlyCountByCategory", 2)
        this.setState({getData: resp});
    }

  render() {
    if(this.state.getData !== null) {
      return (
        <Card className="rounded-4">
          <Card.Body>
          <Card.Title>
              Monthly Communicated Notices
              <div className='float-end'>
                  <span className="fullscreen-link" onClick={() => {renderFullScreen("#lineChartMonthlyNotices")}}>Full Screen</span>
                    <span> | </span>
                  <span className="fullscreen-link" onClick={() => {exportData("MonthlyNotices", this.state.getData)}}>Export</span>
              </div>
          </Card.Title>
          <Card.Subtitle>
              Number of Communicated Notices by Month for ALL instances
          </Card.Subtitle>
          <Chart
            id="lineChartMonthlyNotices"
            palette="Violet"
            dataSource={this.state.getData}
            title={"Monthly Communicated Notices"}
          >
            <CommonSeriesSettings
              argumentField="period"
              type="line"
            />
            {
              axisTitles.map((item) => <Series
                key={item.value}
                valueField={item.value}
                name={item.name} />)
            }
            <Margin bottom={20} />
            <Tooltip
                enabled={true}
                location="edge"
                customizeTooltip={this.customizeTooltip}
                zIndex={10000}
            />
            <ArgumentAxis
              valueMarginsEnabled={false}
              discreteAxisDivisionMode="crossLabels"
            >
              <Label
                  wordWrap="break"
                  overlappingBehavior={"rotate"}
              />
              <Grid visible={true} />
            </ArgumentAxis>
            <Legend
              visible={false}
            />
            <Export enabled={true} />
          </Chart>
          </Card.Body>
        </Card>
      );
    }
  }

  customizeTooltip(arg) {
        return {
            text: `${arg.argumentText} Notices: ${arg.valueText}`,
        }
    }
}

export default lineChartMonthlyNotices;
